import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useCreationPanelStyles = makeStyles((theme: Theme) => ({
	root: {
		backgroundColor: 'rgba(255, 255, 255, 0.2)',
		alignItems: 'center',
		display: 'flex',
		height: '100vh',
		justifyContent: 'center',
		left: 0,
		position: 'fixed',
		top: 0,
		width: '100%',
		zIndex: 1300,
	},
	rootBg: {
		backdropFilter: 'blur(3px)',
		background: 'rgba(0, 0, 0, 0.5)',
		height: '100%',
		left: 0,
		position: 'absolute',
		top: 0,
		width: '100%',
		zIndex: 1,
	},
	container: {
		backgroundColor: 'white',
		boxShadow: '-6px 0px 30px #00000024',
		position: 'relative',
		zIndex: 2,
		borderRadius: 20,
	},
	headerContainer: {
		alignItems: 'center',
		borderBottom: '1px solid rgba(112, 112, 112, 0.16)',
		display: 'flex',
		flexFlow: 'row wrap',
		justifyContent: 'space-between',
		padding: '13px 25px 6px 23px',
	},
	bodyContainer: {
		overflowY: 'auto',
		padding: `16px ${theme.spacing(2)}`,
		scrollbarColor: '#1063AC #E9E9E9',
		scrollbarWidth: 'thin',
		'&::-webkit-scrollbar': {
			width: 6,
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#E9E9E9',
			borderRadius: 7,
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#c7c7c7',
			borderRadius: 7,
		},
	},
	footerContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		padding: theme.spacing(2),
	},
	saveButton: {
		width: 313,
		boxShadow: '0px 1px 3px #00000029 !important',
		borderRadius: '10px !important',
		marginRight: '5px !important',
		'&.Mui-disabled': {
			backgroundColor: '#585858 !important',
			color: 'white !important',
		},
	},
}));

export default useCreationPanelStyles;
